"use strict";
/*
* PluginBase.ts
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT license.
*
* Base export for the Web implementation of the plugin.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var ImageSvg_1 = require("./ImageSvg");
exports.default = ImageSvg_1.default;
var SvgPath_1 = require("./SvgPath");
exports.SvgPath = SvgPath_1.default;
var Types = require("../common/Types");
exports.Types = Types;



//////////////////
// WEBPACK FOOTER
// ./~/reactxp-imagesvg/dist/web/PluginBase.js
// module id = 738
// module chunks = 0